import React, { useMemo } from 'react';
import { MutuoBandeja } from '../models/mutuoBandeja';
import { useNavigate } from 'react-router-dom';
import { FiltroBandeja } from '../models/filtroBandeja';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ActionMenu, { Action } from '../../../components/ui/materialui/actionMenu';
import { OrigenDetalleMutuo, StatusCode, TipoFuncionalidad } from '../../../utils/enums';
import { ingresarMutuo } from '../../detalleMutuo/services/servicesMutuo';
import { useToast } from '../../../hooks/useToast';
import SimpleActionMenu from '../../../components/ui/materialui/simpleActionMenu';
import { usePermissions } from '../../../components/auth/ProtectedRoute';

interface IProps {
  mutuo: MutuoBandeja;
  control: any;
  filtros: FiltroBandeja | any;
  controlTabla?: any;
  setControlTabla?: any;
  refresh: () => void;
}

function useAccionesBandejaMutuo({ mutuo, control, filtros, controlTabla, refresh }: IProps) {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const handleEditarClick = () => {
    navigate(`/mutuos`, {
      state: {
        nombre: mutuo.deudor,
        idSolicitud: mutuo.numerosolicitud,
        filtros: filtros,
        tipoMutuo: mutuo.tipoMutuo,
        origen: OrigenDetalleMutuo.BandejaMutuo,
        id: mutuo.id
      }
    });
  };

  const handleIngresarClick = async () => {
    const response = await ingresarMutuo(mutuo.numerosolicitud.toString(), mutuo.tipoMutuo);
    if (response.status === StatusCode.Ok) {
      if (response.data.comunaWebServiceIndicator) {
        addToast({
          mostrar: true,
          titulo: 'Confirmación',
          tipo: 'Success',
          mensaje: 'Mutuo ingresado correctamente',
        });
      } else {
        addToast({
          mostrar: true,
          titulo: 'Advertencia',
          tipo: 'Warning',
          mensaje: 'Mutuo ingresado. No fue posible obtener la ciudad y comuna, se asignó Santiago por defecto.',
        });
      }
      refresh();
    }
  };

  const filtrosABandeja = filtros as FiltroBandeja;

  const actions = useMemo<Action[]>(() => {
    const items: Action[] = [];

    const estadoMutuo = filtrosABandeja.estadoMutuo?.toUpperCase() || "";

    if (!estadoMutuo || estadoMutuo === "POR_INGRESAR") {
      if (hasPermission(TipoFuncionalidad.Bandeja_ingresar)) {
        items.push({
          label: "Ingresar Mutuo",
          icon: <AddIcon fontSize="small" />,
          onClick: () => handleIngresarClick(),
        });
      }

    } else {
      if (hasPermission(TipoFuncionalidad.Bandeja_ver)) {
        items.push({
          label: "Ver Mutuo",
          icon: <SearchIcon fontSize="small" />,
          onClick: handleEditarClick,
        });
      }

      //! SE COMENTA ESTE CODIGO DEBIDO A QUE DE MOMENTO, SOLAMENTE SERÁ POSIBLE REALIZAR ACTIVACIONES MASIVAS DE MUTUOS (02-06-2025)
      // if (filtrosABandeja.estadoMutuo?.toUpperCase() === "APROBADO") {
      //     if (hasPermission(TipoFuncionalidad.Activar_mutuo)) {
      //     actions.push({
      //         label: "Activar Mutuo",
      //         icon: <CheckIcon fontSize="small" />,
      //         onClick: () => handleEliminarClick()
      //     });
      // }}
    }

    return items;
  }, [filtrosABandeja.estadoMutuo, hasPermission, mutuo.id]);

  return actions;
}


const AccionesBandejaMutuo: React.FC<IProps> = (props) => {
  const actions = useAccionesBandejaMutuo(props);
  return <ActionMenu actions={actions} />;
};

const AccionesContextMenuBandejaMutuo: React.FC<IProps & { handleClose: () => void }> = (props) => {
  const actions = useAccionesBandejaMutuo(props);
  return <SimpleActionMenu actions={actions} handleClose={props.handleClose} />;
};

export { AccionesBandejaMutuo, AccionesContextMenuBandejaMutuo };